import styled from '@emotion/styled';
import COLORS from '$variables/colors';

// eslint-disable-next-line import/prefer-default-export
export const StyledBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
  line-height: 20px;
  font-size: 14px;
  color: ${COLORS.shadow6};
  background-color: ${COLORS.aliceBlue};
  width: 100%;
  box-sizing: border-box;
`;
